import { createFileRoute, redirect } from "@tanstack/react-router";

// English slug moved to /en/outsourced-marketing-director — permanent redirect.
export const Route = createFileRoute("/en/directeur-marketing-externalise")({
  beforeLoad: () => {
    throw redirect({ to: "/en/outsourced-marketing-director", statusCode: 301 });
  },
});
